export type TrackingLinkFormOptions = {
  domains: string[];
  formats: string[];
  trafficSources: { id: string; value: string }[];
};

const getDomainFromUrl = (url: string): string => {
  try {
    return new URL(url).hostname;
  } catch (error) {
    return '';
  }
};

const getTrafficSourceId = (options: TrackingLinkFormOptions, trafficSource: string | null) => {
  if (!trafficSource) return null;

  const foundOption = options.trafficSources
    .find((item) => item.id === trafficSource || item.value === trafficSource);

  return foundOption ? foundOption.id : trafficSource;
};

export const getTrackingLinkFormData = (options: TrackingLinkFormOptions, link?: any) => {
  const finalUrl = link?.finalUrl || '';

  return {
    id: link?.id ?? null,
    created_at: link?.createdAt ?? null,
    updated_at: link?.updatedAt ?? null,
    tracker_id: {
      label: 'tracker_id',
      value: link?.trackerId ?? null,
    },
    creative_id: {
      label: 'creative_id',
      value: link?.creativeId ?? null,
    },
    domain: {
      label: 'domain',
      value: getDomainFromUrl(finalUrl) || options.domains[0] || '',
      options: options.domains.map((item) => ({ id: item, label: item })),
    },
    format: {
      label: 'format',
      value: link?.codeFormat || options.formats[0] || '',
      options: options.formats.map((item) => ({ id: item, label: item })),
    },
    click_id: {
      label: 'click_id',
      value: link?.sub1Macros || '',
    },
    source_id: {
      label: 'source_id',
      value: link?.sub2Macros || '',
    },
    sub_id: {
      label: 'sub_id',
      value: link?.sub3Macros || '',
    },
    source_id4: {
      label: 'source_id4',
      value: link?.sub4Macros || '',
    },
    source_id5: {
      label: 'source_id5',
      value: link?.sub5Macros || '',
    },
    traffic_type: {
      label: 'traffic_type',
      value: getTrafficSourceId(options, link?.trafficSource ?? null),
      options: options.trafficSources,
    },
    final_url: {
      value: finalUrl,
    },
  };
};
